import { Task } from './task'

export interface PatientTasksState {
	tasks: Array<Task>
}

export enum PATIENT_TASKS_STATE_ACTION_TYPES {
	PATIENT_TASKS_GET = 'PATIENT_TASKS_GET',
}

interface PatientTasksGetAction {
	type: PATIENT_TASKS_STATE_ACTION_TYPES.PATIENT_TASKS_GET
	payload: Array<Omit<Task, 'patientsData'>>
}

export type PatientTasksActions = PatientTasksGetAction
